import { Error as ErrorI } from '@abiglobalhealth/go-types'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from 'react'

export interface ErrorsContextProps {
  formErrors: Record<string, string | undefined> | null
  generalErrors: ErrorI[] | null

  setFormErrors: Dispatch<SetStateAction<Record<string, string | undefined> | null>>
  setGeneralErrors: Dispatch<SetStateAction<ErrorI[] | null>>
}

export const ErrorsContext = createContext({} as ErrorsContextProps)

export const ErrorsProvider = ({ children }: PropsWithChildren) => {
  const [formErrors, setFormErrors] = useState<ErrorsContextProps['formErrors']>(null)
  const [generalErrors, setGeneralErrors] = useState<ErrorsContextProps['generalErrors']>(null)

  const value = {
    formErrors,
    generalErrors,
    setFormErrors,
    setGeneralErrors
  }

  return <ErrorsContext.Provider value={value}>{children}</ErrorsContext.Provider>
}
